import { useState, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { CreditLimitModal } from '../components/CreditLimitModal';
import { fetchCreditBalance, hasEnoughCredits } from '../utils/credit-check';

export const useCreditCheck = () => {
  const { token } = useAuth();
  const [showModal, setShowModal] = useState(false);

  const checkCredits = useCallback(async (requiredCredits = 0): Promise<boolean> => {
    if (!token) {
      return false;
    }

    try {
      const balance = await fetchCreditBalance(token);

      if (balance === null) {
        return true;
      }

      if (!hasEnoughCredits(balance, requiredCredits)) {
        setShowModal(true);
        return false;
      }

      return true;
    } catch (error) {
      console.error('Error checking credits:', error);
      return true;
    }
  }, [token]);

  const showCreditLimitModal = useCallback(() => {
    setShowModal(true);
  }, []);

  const CreditLimitModalComponent = (
    <CreditLimitModal open={showModal} onOpenChange={setShowModal} />
  );

  return {
    checkCredits,
    showCreditLimitModal,
    CreditLimitModalComponent,
  };
};

